import cx from "classnames";
import React from "react";
import ItemLink from "./ItemLink";
import styles from "./TabMenu.module.scss";
const TabMenu = ({ setOpenTab, setOpenTabMobile, setOpen, open, child, resetStates, openTab, openTabMobile, }) => (<>
    <button onClick={() => setOpen(true)} className={styles.mobileOpenButton}>
      Open
    </button>
    <div className={cx(styles.tabMenu, "flexOnHover", {
        [styles.mobileOpen]: open,
    })} data-label={child === null || child === void 0 ? void 0 : child.tabmenuLabel}>
      <button onClick={() => setOpen(false)} className={styles.mobileCloseButton}>
        Back
      </button>

      <div className={styles.tabMobileParentLink}>
        {!child.url ? (child.name) : (<ItemLink child={child} className={styles.linkItem} resetStates={resetStates}/>)}
      </div>
      {child.tabmenu.map((tabChild, key) => (<div key={tabChild.name} className={styles.tabItemOrderFix}>
          <button onClick={() => setOpenTab(key)} className={`${styles.desktopTabButton} ${openTab === key ? styles.active : ""}`}>
            {tabChild.name}
          </button>
          <button onClick={() => setOpenTabMobile(key)} className={styles.mobileTabButton}>
            {tabChild.name}
          </button>
          <div className={cx(styles.tabList, {
            [styles.tabListOpenDesktop]: openTab === key,
            [styles.tabListOpenMobile]: openTabMobile === key,
        })}>
            <button onClick={() => setOpenTabMobile(null)} className={styles.mobileCloseButton}>
              Back
            </button>
            {tabChild.submenu.map((menu) => (<div key={menu.name} className={styles.tabMenuBlock}>
                {!menu.url ? (<span className={`${styles.tabLink} ${styles.heading} ${styles.disabled}`}>
                    {menu.name}
                  </span>) : (<ItemLink child={menu} resetStates={resetStates} className={`${styles.tabLink} ${styles.heading}`}/>)}

                {menu.submenu.map((menuItem) => (<React.Fragment key={menuItem.name}>
                    {!menuItem.url ? (<span className={`${styles.tabLink} ${styles.disabled}`}>
                        {menuItem.name}
                      </span>) : (<ItemLink child={menuItem} className={styles.tabLink} resetStates={resetStates}/>)}
                  </React.Fragment>))}
              </div>))}
          </div>
        </div>))}
    </div>
  </>);
export default TabMenu;
